import * as React from "react";
const SvgFiRrClub = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-club_svg__a)">
      <path
        fill="#062147"
        d="M23 14a6 6 0 0 0-5.606-5.98A5.46 5.46 0 0 0 18 5.546 5.793 5.793 0 0 0 12 0a5.793 5.793 0 0 0-6 5.546 5.45 5.45 0 0 0 .607 2.474A6 6 0 0 0 7 20a5.6 5.6 0 0 0 3.938-1.807C10.773 20.755 10.156 22 8 22H6a1 1 0 1 0 0 2h12a1 1 0 0 0 0-2h-2c-2.156 0-2.773-1.245-2.938-3.807A5.6 5.6 0 0 0 17 20a6.006 6.006 0 0 0 6-6M12 2a3.8 3.8 0 0 1 4 3.546c0 2.133-2.1 3.534-2.189 3.593a1 1 0 0 0-.08.078 9 9 0 0 0-1.73 1.836 9 9 0 0 0-1.733-1.837c-.025-.019-.039-.047-.066-.065l-.145-.1-.03-.025A4.72 4.72 0 0 1 8 5.546 3.8 3.8 0 0 1 12 2m-.029 20 .03-.047q.014.023.028.047zm.94-7.414a1 1 0 0 0-1.82-.003C11.074 14.618 9.49 18 7 18a4 4 0 1 1 0-8c.679.018 1.335.25 1.875.662.075.055.13.094.174.124a8.2 8.2 0 0 1 2.04 2.628 1 1 0 0 0 1.82.003C12.925 13.382 14.51 10 17 10a4 4 0 1 1 0 8c-2.49 0-4.075-3.382-4.09-3.414"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-club_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrClub;
